import React from "react";
import {
  DataGrid,
  GridColumnMenu,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { Box } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
export default function MuiGrid({
  data,
  columns,
  filters,
  noToolbar,
  fileName,
  ...props
}) {
  function CustomToolbar() {
    return (
      <GridToolbarContainer sx={{ borderTop: "0 solid #e5e7eb", order: "1" }}>
        <GridToolbarColumnsButton />
        {/* <GridToolbarDensitySelector
        slotProps={{ tooltip: { title: 'Change density' } }}
      /> */}
        <Box sx={{ flexGrow: 1 }} />
        <GridToolbarExport
          printOptions={{
            hideFooter: true,
            hideToolbar: true,
          }}
          csvOptions={{
            fileName: `${fileName}`,
          }}
          slotProps={{
            tooltip: { title: "Export data" },
          }}
        />
      </GridToolbarContainer>
    );
  }
  function CustomColumnMenu(props) {
	return (
	  <GridColumnMenu
		{...props}
		slots={{
		  // Hide `columnMenuColumnsItem`
		  columnMenuColumnsItem: null,
		}}
	  />
	);
  }
  

  if (filters) {
    return (
      <DataGridPro
        rows={data}
        columns={columns}
        filterModel={{
          items: filters,
        }}
        rowSpanning
        // slots={{
        //   toolbar: CustomToolbar,
        // }}
        {...props}
        showToolbar />
    );
  } else if (noToolbar) {
    return (
      <DataGridPro
        rows={data}
        columns={columns}
        rowSpanning
        {...props}
		slots={{ columnMenu: CustomColumnMenu }}
      />
    );
  } else {
    return (
      <DataGridPro
        rows={data}
        columns={columns}
        rowSpanning
        // slots={{
        //   toolbar: CustomToolbar,
        // }}
        {...props}
        showToolbar />
    );
  }
}
